import { RRIInput } from './input-settings.interface';

export interface RRITimeFieldInput extends RRIInput<Date> {
  showMeridian?: boolean;
  showSeconds?: boolean;
  showTimePicker?: boolean;
  /**
   * @deprecated showSpinners is not used anymore
   */
  showSpinners?: boolean /* deprecated */;
}
